
import React, { useState } from "react";
import { AiOutlineClose } from "react-icons/ai"; // Import close icon
import DisableAccount from "../disable-account";
import useOutsideClick from "hooks/click-outside";
import useAuth from "containers/auth/useHooks";
import { confirmationPopup } from "utils/helpers/common/alert-service";
import { ROLES } from "utils/helpers/enums/roles.enum";


type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  role?: ROLES;
};

const AccountAction: React.FC<ModalProps> = ({ isOpen, onClose, role }) => {
  const [isDisableModalOpen, setIsDisableModalOpen] = useState(false);
  const {setDefaultRole} = useAuth();
  const openDisableModal = () => setIsDisableModalOpen(true);

  const closeModals = () => {
    setIsDisableModalOpen(false);
  };
  const modalRef = useOutsideClick(onClose);

  if (!isOpen) return null;

  const handleSetDefaultRole = async () => {
    const result = await confirmationPopup(`Are you sure you want to set ${role} as your default role?`);
    if(result.isConfirmed){
      setDefaultRole({role});
    }
  }

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      style={{ zIndex: 'calc(var(--z-modal) + 1)' }}
    >
      <div
        ref={modalRef}
        className={`relative bg-white px-6 py-8 rounded-lg shadow-lg w-[90%] sm:w-[375px] transform transition-transform duration-300 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 transition"
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl text-center text-primaryBlueText font-bold mb-4">
          Account Action
        </h2>
        <div className="flex flex-col ">
          {/* <span
            onClick={() => setIsDisableModalOpen(true)}
            className="text-base text-center text-primaryBlueText py-4 bordr-linear cursor-pointer"
          >
            Disable Account
          </span> */}
          <span className="text-base text-center text-primaryBlueText pt-4 cursor-pointer" onClick={handleSetDefaultRole}>
            Set Account as Default
          </span>
        </div>
      </div>
      {isDisableModalOpen && (
        <DisableAccount isOpen={isDisableModalOpen} onClose={closeModals} />
      )}
    </div>
  );
};

export default AccountAction;
